import { Component, OnInit } from '@angular/core';
//import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { Router }  from '@angular/router';

import { Credential } from './credential';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

@Component({
  selector: 'cef-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {
    //profileData: FirebaseObjectObservable<any>;
    user: Observable<firebase.User>;
    helpUrl: SafeResourceUrl;
    credentail = new Credential('','');
    registerUser = {
        email:'',
        password:'',
        name:'',
        dateOfBirth:'',
        gender:'',
        unit:'',
        group:''
    }
    loginMsg = '';
    regMsg = '';
	constructor(public sanitizer:DomSanitizer, private router: Router, private memberService: MemberService, private afAuth: AngularFireAuth, public db: AngularFireDatabase) {
        //this.user = afAuth.authState;
    }

    ngOnInit() {
        this.helpUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.lovekid.hk/images/iframe/register/');
    }

	register(){
		this.regMsg = '處理中，請稍候！';
		//firebase.auth().createUserWithEmailAndPassword(this.credentail.email, this.credentail.password).then(
        if (this.registerUser.email == ''){
            this.regMsg = '請輸入電郵!'
            return
        }
        if (this.registerUser.password == ''){
            this.regMsg = '請輸入密碼!'
            return
        }
        if (this.registerUser.password.length < 6){
            this.regMsg = '密碼最少6個字!'
            return
        }
        if (this.registerUser.name == ''){
            this.regMsg = '請輸入會員名稱!'
            return
        }
        if (this.registerUser.dateOfBirth == ''){
            this.regMsg = '請輸入出生日期!'
            return
        }
        if (this.registerUser.gender == ''){
            this.regMsg = '請選擇性別!'
            return
        }
        if (this.registerUser.unit == ''){
            this.regMsg = '請輸入所屬學校/教會/團體!'
            return
        }
        if (this.registerUser.group == ''){
            this.regMsg = '請輸入班別!'
            return
        }
        this.afAuth.auth.createUserWithEmailAndPassword(this.registerUser.email, this.registerUser.password).then(
        	result => {
        		//var user = firebase.auth().currentUser;
                var user = this.afAuth.auth.currentUser;
                let db = firebase.database();
               db.ref('profile/' + user.uid).set({
                    name: this.registerUser.name,
                    level: 5,
                    dateOfBirth: this.registerUser.dateOfBirth,
                    gender: this.registerUser.gender,
                    unit: this.registerUser.unit,
                    group:this.registerUser.group.toLowerCase(),
                    tutor: '',
                    created: (new Date()).toString(),
                    createdBy: user.uid,
                    modified: (new Date()).toString(),
                    modifiedBy: user.uid
                }).then(
                    result => {
                        user.sendEmailVerification().then(
                            r => {
                              this.regMsg = '確認電郵已發送到所註冊電郵地址。您現在可以用註冊電郵及密碼登入';
                              //setTimeout(()=>{this.regMsg = '';},this.memberService.modalDismiss);
                              //this.router.navigate(['/member/dashboard']);
                            }
                        );
                    }
                ).catch(
                    (error:any) => {
                        this.regMsg = error.code;
                        setTimeout(()=>{this.regMsg = '';},this.memberService.modalDismiss);
                    }
                );
            }
        ).catch(
        	(error:any) => {
        		console.log(error.code);
        		if (error.code == 'auth/email-already-in-use'){
        			this.regMsg = '電郵已被使用，請用另外一個電郵註冊。';
                    setTimeout(()=>{this.regMsg = '';},this.memberService.modalDismiss);
        		} else if (error.code == 'auth/invalid-email'){
        			this.regMsg = '輸入的電郵無效。';
                    setTimeout(()=>{this.regMsg = '';},this.memberService.modalDismiss);
                } else if (error.code == 'weak-password'){
                    this.regMsg = '輸入的密碼無效。';
                    setTimeout(()=>{this.regMsg = '';},this.memberService.modalDismiss);
                }
        	}
        )
    }

    forgetPw(){
    	if (this.credentail.email == ''){
    		this.loginMsg = '新輸入電郵地址！';
            setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
    	} else {
    		this.loginMsg = '處理中，請稍候！';
            setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
    		//firebase.auth().sendPasswordResetEmail(this.credentail.email).then(
            this.afAuth.auth.sendPasswordResetEmail(this.credentail.email).then(
    			result => {
    				this.loginMsg = '密碼重設電郵已發送到上述電郵地址。';
                    setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
    			}
    		).catch(
    			(error:any) => {
    				if (error.code == "auth/invalid-email") {
    					this.loginMsg = "電郵地址無效！";
                        setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
    				} else if (error.code == "auth/user-not-found") {
    					this.loginMsg = "找不到註冊用戶！";
                        setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
    				}
    				
    			}
    		)
    	}
    }

	login(){
		//firebase.auth().signInWithEmailAndPassword(this.credentail.email, this.credentail.password)
        this.afAuth.auth.signInWithEmailAndPassword(this.credentail.email, this.credentail.password)
		.then(
        	result => {
                //let user = firebase.auth().currentUser;
                let user = this.afAuth.auth.currentUser;
                let db = firebase.database();
                db.ref('profile/'+user.uid).once('value').then(
                   (snapshot:any) => {
                       this.memberService.logAct('login',user.uid, snapshot.val().level);
                        if (snapshot.val().level == 0 ||  snapshot.val().level == 1){
                            this.router.navigate(['/webadmin/memberList']);
                        } else if (snapshot.val().level== 2 || snapshot.val().level == 3) {
                            this.router.navigate(['/webadmin/message']);
                        } else {
                            this.router.navigate(['/member/dashboard']);
                        }   
                    }
                )
            }
        ).catch(
        	(error:any) => {
                if (error.code == 'auth/wrong-password') {
                    this.loginMsg = "密碼不符！";
                    setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
                } else if (error.code == 'auth/user-not-found') {
                    this.loginMsg = "找不到註冊用戶！";
                    setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
                } else {
                    this.loginMsg = error.message;
                    setTimeout(()=>{this.loginMsg = '';},this.memberService.modalDismiss);
                }
        		
        	}
        )
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/core/login.component.ts